export default "__VITE_ASSET__$zLaZVWT__"